import React from "react";
import styles from "./Style.module.css";
import Header from "./Header";
import Lessons from "./Lessons";
import psychology from "constants/psychology";
import ShareButtons from "./ShareButtons";

const Microlessons = () => {
  const rand = Math.floor(Math.random() * 36);
  const lesson = psychology[rand];

  return (
    <div
      className={`container-fluid d-flex flex-column align-items-center p-0 m-0 ${styles.container}`}
    >
      <div className={`${styles.header} text-center p-0`}>
        <Header />
      </div>
      <Lessons lesson={lesson} />
      <div style={{ width: "60vw" }}>
        <ShareButtons lesson={lesson} />
      </div>
    </div>
  );
};

export default Microlessons;
